export default __webpack_public_path__ + "static/media/minusIcon.4de05b00.svg";